module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('doc-section', {
    attrs: {
      "id": "radio",
      "name": "Radio"
    }
  }, [_vm._c('div', {
    staticClass: "bs-example"
  }, [_vm._c('h4', [_vm._v("Radio")]), _vm._v(" "), _vm._c('radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "selected-value": "one"
    },
    domProps: {
      "value": (_vm.radioValue)
    },
    on: {
      "input": function($event) {
        _vm.radioValue = $event
      }
    }
  }, [_vm._v("One")]), _vm._v(" "), _vm._c('radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "selected-value": "two",
      "type": "danger",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.radioValue)
    },
    on: {
      "input": function($event) {
        _vm.radioValue = $event
      }
    }
  }, [_vm._v("Two (disabled)")]), _vm._v(" "), _vm._c('radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "selected-value": "two",
      "type": "warning",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.radioValue)
    },
    on: {
      "input": function($event) {
        _vm.radioValue = $event
      }
    }
  }, [_vm._v("Two (readonly)")]), _vm._v(" "), _vm._c('radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "selected-value": "two",
      "type": "success"
    },
    domProps: {
      "value": (_vm.radioValue)
    },
    on: {
      "input": function($event) {
        _vm.radioValue = $event
      }
    }
  }, [_vm._v("Two")]), _vm._v(" "), _vm._c('hr'), _vm._v(" "), _vm._c('h4', [_vm._v("Radio Button (Single buttons)")]), _vm._v(" "), _vm._c('radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "button": "",
      "selected-value": "three",
      "type": "primary"
    },
    domProps: {
      "value": (_vm.radioValue)
    },
    on: {
      "input": function($event) {
        _vm.radioValue = $event
      }
    }
  }, [_vm._v("Three")]), _vm._v(" "), _vm._c('radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "button": "",
      "selected-value": "four",
      "type": "info",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.radioValue)
    },
    on: {
      "input": function($event) {
        _vm.radioValue = $event
      }
    }
  }, [_vm._v("Four (disabled)")]), _vm._v(" "), _vm._c('radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "button": "",
      "selected-value": "four",
      "type": "info",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.radioValue)
    },
    on: {
      "input": function($event) {
        _vm.radioValue = $event
      }
    }
  }, [_vm._v("Four (readonly)")]), _vm._v(" "), _vm._c('radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "button": "",
      "selected-value": "four",
      "type": "info"
    },
    domProps: {
      "value": (_vm.radioValue)
    },
    on: {
      "input": function($event) {
        _vm.radioValue = $event
      }
    }
  }, [_vm._v("Four")]), _vm._v(" "), _vm._c('p', [_vm._c('pre', [_vm._v("Radio value: " + _vm._s(_vm.radioValue))])])], 1), _vm._v(" "), _vm._c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n    <radio v-model=\"radioValue\" selected-value=\"one\">One</radio>\n    <radio v-model=\"radioValue\" selected-value=\"two\" type=\"danger/warning/success\">Two</radio>\n    <radio button v-model=\"radioValue\" selected-value=\"three\" type=\"primary\">Three</radio>\n    <radio button v-model=\"radioValue\" selected-value=\"four\" type=\"info\">Four</radio>\n  ")]), _vm._v(" "), _vm._c('doc-table', [_vm._c('div', [_vm._c('p', [_vm._v("button")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Boolean")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("false")])]), _vm._v(" "), _vm._c('p', [_vm._v("Enable/Disable button style.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("selected-value")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Mixed")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("true")])]), _vm._v(" "), _vm._c('p', [_vm._v("Value to return if the radio item is selected.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("type")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")]), _vm._v(", one of "), _vm._c('code', [_vm._v("default")]), _vm._v(" "), _vm._c('code', [_vm._v("primary")]), _vm._v(" "), _vm._c('code', [_vm._v("danger")]), _vm._v(" "), _vm._c('code', [_vm._v("info")]), _vm._v(" "), _vm._c('code', [_vm._v("warning")]), _vm._v(" "), _vm._c('code', [_vm._v("success")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("default")])]), _vm._v(" "), _vm._c('p')]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("value")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Mixed")])]), _vm._v(" "), _vm._c('p'), _vm._v(" "), _vm._c('p', [_vm._v("Handle the selected value.")])])]), _vm._v(" "), _vm._c('p', [_vm._v("See "), _vm._c('a', {
    attrs: {
      "href": "#button-group"
    }
  }, [_vm._v("Button Group")]), _vm._v(" for more options.")])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f85b88c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f85b88c!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/radioDocs.vue
// module id = 250
// module chunks = 0